<template>
  <!-- eslint-disable max-len -->
  <svg
    v-if="enabled"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 100 100"
    style="enable-background:new 0 0 100 100;"
    xml:space="preserve"
  >
    <g>
      <path
        style="fill-rule:evenodd;clip-rule:evenodd;"
        d="M50,0c13.807,0,26.307,5.597,35.355,14.645C94.404,23.693,100,36.193,100,50
      c0,13.807-5.596,26.307-14.645,35.355C76.307,94.403,63.807,100,50,100s-26.307-5.597-35.355-14.645C5.597,76.307,0,63.807,0,50
      c0-13.807,5.597-26.307,14.645-35.355C23.693,5.597,36.193,0,50,0L50,0z M57.509,69.936c-1.608,0-2.912-1.304-2.912-2.912
      s1.304-2.912,2.912-2.912h5.238c0.402,0,0.762-0.159,1.018-0.415l0.012-0.011c0.256-0.256,0.415-0.616,0.415-1.018v-5.329
      c0-1.608,1.304-2.912,2.912-2.912c1.608,0,2.912,1.304,2.912,2.912v5.329c0,1.985-0.814,3.796-2.126,5.117l-0.007,0.007
      l-0.006,0.006l-0.006,0.006c-1.321,1.316-3.135,2.133-5.124,2.133H57.509L57.509,69.936z M42.491,64.112
      c1.608,0,2.912,1.304,2.912,2.912s-1.304,2.912-2.912,2.912h-5.238c-1.994,0-3.808-0.817-5.124-2.133l-0.011-0.012
      c-1.316-1.316-2.133-3.13-2.133-5.124v-5.329c0-1.608,1.304-2.912,2.912-2.912c1.608,0,2.912,1.304,2.912,2.912v5.329
      c0,0.396,0.159,0.756,0.415,1.018l0.011,0.011c0.262,0.256,0.622,0.415,1.018,0.415H42.491L42.491,64.112z M57.509,35.888
      c-1.608,0-2.912-1.304-2.912-2.912c0-1.608,1.304-2.912,2.912-2.912h5.238c1.989,0,3.803,0.816,5.124,2.133l0.006,0.006
      l0.006,0.006l0.007,0.007c1.313,1.321,2.126,3.132,2.126,5.117v5.329c0,1.608-1.304,2.912-2.912,2.912
      c-1.608,0-2.912-1.304-2.912-2.912v-5.329c0-0.402-0.159-0.762-0.415-1.018l-0.011-0.011c-0.256-0.256-0.616-0.415-1.018-0.415
      H57.509L57.509,35.888z M42.491,30.064c1.608,0,2.912,1.304,2.912,2.912c0,1.608-1.304,2.912-2.912,2.912h-5.238
      c-0.396,0-0.756,0.159-1.018,0.415l-0.011,0.011c-0.256,0.262-0.415,0.622-0.415,1.018v5.329c0,1.608-1.304,2.912-2.912,2.912
      c-1.608,0-2.912-1.304-2.912-2.912v-5.329c0-1.994,0.817-3.808,2.133-5.124l0.011-0.011c1.316-1.316,3.13-2.133,5.124-2.133H42.491
      L42.491,30.064z"
      />
    </g>
  </svg>
  <svg
    v-else
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 107.1 107.1"
    style="enable-background:new 0 0 107.1 107.1;"
    xml:space="preserve"
  >
    <g>
      <path
        style="stroke-width:7.0866;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256"
        d="M53.5,3.5c27.6,0,50,22.4,50,50s-22.4,50-50,50s-50-22.4-50-50S25.9,3.5,53.5,3.5L53.5,3.5z M45.6,35.5H40
      c-2.5,0-4.6,2.1-4.6,4.6v5.7 M61.5,35.5h5.6c2.5,0,4.6,2.1,4.6,4.6v5.7 M45.6,71.6H40c-2.5,0-4.6-2.1-4.6-4.6v-5.7 M61.5,71.6h5.6
      c2.5,0,4.6-2.1,4.6-4.6v-5.7"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'FullscreenIcon',

  props: {
    enabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
